import _get from 'lodash/get';
import { getContenfulFilters } from 'containers/Main/utils';
import ctf from 'utils/contentfulService';
import { mapEntryWithTranslationLink } from 'containers/ResourceController/utils';
import { getArticlesMinimumWordCount } from 'containers/Resources/utils';

const getArticles = async (
  _key,
  {
    type,
    shouldFilterShortArticles = false,
    clientExcludedTopic,
    averageRatingCutoff,
    expertRatingCutoff,
    userRatingCutoff,
    payload,
    localeFilters,
    featuresConfig,
    clientDetails,
  },
) => {
  const contentfulFilters = getContenfulFilters(
    clientExcludedTopic,
    averageRatingCutoff,
    expertRatingCutoff,
    userRatingCutoff,
  );
  const finalLocaleFilters =
    _get(localeFilters, 'locale') === 'en-US' ? {} : localeFilters;
  const articlesMinimumWordCount = getArticlesMinimumWordCount(
    featuresConfig,
    clientDetails,
  );
  const shortArticlesFilters = shouldFilterShortArticles
    ? {
        'fields.wordCount[gte]': articlesMinimumWordCount,
      }
    : {};

  const response = await ctf.getEntries({
    content_type: type,
    'fields.reviewStatus': 'Accepted',
    limit: 5,
    include: 1,
    ...contentfulFilters,
    ...payload,
    ...finalLocaleFilters,
    ...shortArticlesFilters,
  });

  const updatedItems = response?.items.map(mapEntryWithTranslationLink);

  return {
    ...response,
    items: updatedItems,
  };
};

export default getArticles;
